import moment from 'moment';
import { USER_TIME_FORMAT } from 'shared/constants/date';
import type { TeacherWorkloadWorkDayFormRow } from '../types';

export const validateWorkDaysSchedule = (_: unknown, value: TeacherWorkloadWorkDayFormRow[]) => {
  if (!value || value.length === 0) {
    return Promise.reject(new Error('Настройте рабочие дни'));
  }

  const hasActiveDay = value.some((row) => row.mode === 'unlimited' || row.mode === 'interval');
  if (!hasActiveDay) {
    return Promise.reject(new Error('Выберите хотя бы один рабочий день'));
  }

  for (const row of value) {
    if (row.mode !== 'interval') continue;
    const start = moment(row.startTime, USER_TIME_FORMAT, true);
    const end = moment(row.endTime, USER_TIME_FORMAT, true);
    if (!start.isValid() || !end.isValid()) {
      return Promise.reject(new Error('Укажите время для всех дней с режимом «Время»'));
    }
    if (!start.isBefore(end)) {
      return Promise.reject(new Error('Время окончания должно быть позже времени начала'));
    }
  }

  return Promise.resolve();
};
